export default "__VITE_ASSET__C8JKo$OI__"